@let canLinkRisks = (canLinkRisks$ | async) === true;
@if (state$ | async; as state) {
    @switch (state.status) {
        @case ("loading") {
            <p role="status">{{ "linkedItems.loading" | t }}</p>
        }
        @case ("error") {
            <p role="alert">{{ "linkedItems.loadError" | t }}</p>
            <cerrix-button
                buttonType="secondary"
                [text]="'linkedItems.retry' | t"
                (click)="loadRisks()"
            />
        }
        @case ("loaded") {
            <app-linked-risk-row #riskTemplates (confidentialRowClick)="onConfidentialRiskClicked()" />
            <app-cerrix-linked-item-table
                [title]="'linkedItems.risks.risksTitle' | t: {} : translationScope"
                [items]="state.items"
                [templates]="riskTemplates"
                [loadDetails]="loadRiskDetails"
                [canLink]="canLinkRisks"
                [unlinkConfirmation]="{
                    title: 'linkedItems.risks.unlinkDialogTitle' | t,
                    description: 'linkedItems.risks.unlinkDialogDescription' | t
                }"
                (linkItems)="onLinkRisks(state.items)"
                (openItem)="onOpenLinkedRisk($event)"
                (unlinkItem)="onUnlinkRisk($event)"
            />
        }
    }
}
<app-cerrix-link-items-dialog
    [name]="linkDialogName"
    [title]="'linkedItems.risks.linkDialogTitle' | t"
    [items]="linkableItems()"
    [selectedIds]="linkedRiskIds()"
    (confirmed)="onConfirmLinkRisks($event)"
    (itemDetailsRequested)="onOpenLinkableRisk($event)"
/>
